import { MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Injectable } from '@angular/core';

import { BehaviorScreen } from '../../models/view-models/monitor-models/screen.type';
import { Schedule } from '../../models/entities/schedule.type';
import { MonitorMenuComponent } from '../../../components/monitor-menu/monitor-menu.component';
import { TimelineMonitorMenuComponent } from '../../../components/monitor-menu/timeline-monitor-menu.component';
import { AppConstants } from '../../../app.constants';
import { ScreensStateService } from '../screen-state/screens-state.service';

const _window = window;

@Injectable()
export class MonitorMenuService {

    monitorContextMenuInstance: MatDialogRef<MonitorMenuComponent>;
    timelineContextMenuInstance: MatDialogRef<TimelineMonitorMenuComponent>;

    constructor(public dialog: MatDialog, private readonly screenStateService: ScreensStateService) { }

    private _setMenuPosition(xCoords: number, yCoords: number): { top: string, left: string } {
        const subtraction = +_window.innerHeight - yCoords;
        return subtraction < AppConstants.DEFAULT_MONITOR_MENU_HEIGHT
            ? {
                top: `${_window.innerHeight < AppConstants.DEFAULT_MONITOR_MENU_HEIGHT ? 0 : (_window.innerHeight - AppConstants.DEFAULT_MONITOR_MENU_HEIGHT)}` + 'px',
                left: xCoords + 'px'
            }
            : { top: yCoords + 'px', left: xCoords + 'px' };
    }

    public showMonitorMenu(screen: BehaviorScreen, x: number, y: number, isBroadcasting: boolean = false) {

        if (this.monitorContextMenuInstance) {
            this.monitorContextMenuInstance.close();
        }

        this.monitorContextMenuInstance = this.dialog.open(MonitorMenuComponent, {
            backdropClass: 'classs',
            panelClass: 'monitor-menu',
            position: this._setMenuPosition(x, y),
            hasBackdrop: false
        });

        this.monitorContextMenuInstance.componentInstance.monitor = screen;
        this.monitorContextMenuInstance.componentInstance.serviceRef = this;
        this.monitorContextMenuInstance.componentInstance.isBroadcasting = isBroadcasting;
    }

    public showTimelineMonitorMenu(screen: BehaviorScreen, schedule: Schedule, x: number, y: number) {

        this.screenStateService.connectScreens([screen]);

        if (this.timelineContextMenuInstance) {
            this.timelineContextMenuInstance.close();
        }

        this.timelineContextMenuInstance = this.dialog.open(TimelineMonitorMenuComponent, {
            backdropClass: 'classs',
            panelClass: 'monitor-menu',
            position: this._setMenuPosition(x, y)
        });

        this.timelineContextMenuInstance.componentInstance.monitor = screen;
        this.timelineContextMenuInstance.componentInstance.schedule = schedule;
        this.timelineContextMenuInstance.componentInstance.isBroadcasting = true;
        this.timelineContextMenuInstance.componentInstance.serviceRef = this;
    }

    public closeDialog() {

        if (this.monitorContextMenuInstance) {
            this.monitorContextMenuInstance.close();
        }

        if (this.timelineContextMenuInstance?.componentInstance) {
            this.screenStateService.disconnectScreens([this.timelineContextMenuInstance.componentInstance.monitor]);
            this.timelineContextMenuInstance.close();
        }
    }


}
